export const getDisplayInfoForLocale = (displayInfoArray, baseLocale) =>
  displayInfoArray?.find(
    displayInfo =>
      displayInfo?.languageCode?.toLowerCase() === baseLocale ||
      displayInfo?.langCode?.toLowerCase() === baseLocale,
  ) ??
  displayInfoArray?.[0] ??
  {};
